import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';
import { useDeviceType } from '../../hooks/useDeviceType';

const ThemeSwitcher = () => {
  const { t } = useTranslation();
  const { isDarkMode, toggleTheme, colors } = useTheme();

  const { isMobile } = useDeviceType();

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: isMobile ? '0.3rem' : '0.5rem'
  };

  const switchContainerStyle = {
    position: 'relative',
    width: isMobile ? '44px' : '50px',
    height: isMobile ? '22px' : '24px',
    borderRadius: '12px',
    background: isDarkMode
      ? '#4a90e2'
      : 'rgba(74, 144, 226, 0.2)',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    border: `2px solid ${isDarkMode ? 'transparent' : colors.border}`,
    boxShadow: isDarkMode ? '0 2px 8px rgba(74, 144, 226, 0.3)' : 'none'
  };

  const switchBallStyle = {
    position: 'absolute',
    top: '2px',
    left: isDarkMode ? 'calc(100% - 18px)' : '2px',
    width: isMobile ? '14px' : '16px',
    height: isMobile ? '14px' : '16px',
    borderRadius: '50%',
    background: 'white',
    transition: 'all 0.3s ease',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: isMobile ? '8px' : '10px'
  };

  return (
    <div style={containerStyle}>
      <div
        style={switchContainerStyle}
        onClick={toggleTheme}
        title={t('theme.toggle')}
        role="switch"
        aria-checked={isDarkMode}
        tabIndex={0}
        onKeyPress={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleTheme();
          }
        }}
      >
        <div style={switchBallStyle}>
          {isDarkMode ? '🌙' : '☀️'}
        </div>
      </div>
    </div>
  );
};

export default ThemeSwitcher; 
